<template>
  <div>
    <EditButton :disabled="!$atividades.permissoes.includes(14)" @func="modalEditarMetodologia = true"></EditButton>
    <SideBar
      title="Editar metodologia"
      @hide="cancelar"
      :active="modalEditarMetodologia"
      :item="metodologia"
      textSucces="Atualizar"
      :disabled="!$atividades.permissoes.includes(15)"
      @excluir="exluirMetodologia"
      @status="mudarStatusMetodologia"
      icon="edit"
      size="small"
      @success="submitForm()"
    >
      <div slot="body">
        <vs-row class="mb-4" vs-type="flex" vs-w="12">
          <vs-col vs-w="12">
            <vs-input
              class="inputx w-full"
              label-placeholder="Nome"
              v-model="metodologia.nome"
              name="nome"
              v-validate="'required'"
            />
            <span class="text-danger text-sm" v-show="errors.has('nome')">{{
              $validators.empty
            }}</span>
          </vs-col>
        </vs-row>
      </div>
    </SideBar>
  </div>
</template>

<script>
import components from "@/components/default/exports.js";

export default {
  name: "modalEditarMetodologia",
  props: { metodologia: Object },
  data() {
    return {
      modalEditarMetodologia: false,
      error: false,
      originalData: {}
    };
  },
  mounted() {
    this._beforeEditingCache = Object.assign({}, this.metodologia);
    this.originalData = this.metodologia;
  },
  methods: {
    async submitForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.editarMetodologia();
        } else {
          this.error = true;
          this.$vs.notify(this.$notify.Empty);
        }
      });
    },
    async editarMetodologia() {
      this.$vs.loading();
      try {
        const res = await this.$http.put(
          `metodologia/${this.metodologia.id}`,
          this.metodologia
        );
        let logData = {
            id_colaborador: localStorage.getItem("id"),
            funcao: 'atualizar',
            setor: 'comercial',
            ip: window.localStorage.getItem("ip"),
            texto: 'Edição da metodologia N°' + res.id}
          await this.$logger(logData)
        this.modalEditarMetodologia = false;
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        };
      } finally {
        this.$vs.loading.close();
      }
    },
    async exluirMetodologia() {
      this.$vs.loading();
      try {
        await this.$http.delete(`metodologia/${this.metodologia.id}`);
        let logData = {
            id_colaborador: localStorage.getItem("id"),
            funcao: 'excluir',
            setor: 'comercial',
            ip: window.localStorage.getItem("ip"),
            texto: 'Exclusão da metodologia N°' + this.metodologia.id}
          await this.$logger(logData)
        this.modalEditarMetodologia = false;
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        };
      } finally {
        this.$vs.loading.close();
        this.$emit("update");
      }
    },
    async mudarStatusMetodologia() {
      this.$vs.loading();
      try {
        const res = await this.$http.put(`metodologia/${this.metodologia.id}`, {
          lixeira: !this.metodologia.lixeira
        });
        let logData = {
            id_colaborador: localStorage.getItem("id"),
            funcao: 'atualizar',
            setor: 'comercial',
            ip: window.localStorage.getItem("ip"),
            texto: 'Mudança do status da metodologia N°' + res.id}
          await this.$logger(logData)
        this.$vs.notify(this.$notify.Success);
        this.modalEditarMetodologia = false;
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        };
      } finally {
        this.$vs.loading.close();
        this.$emit("update");
      }
    },
    cancelar() {
      Object.assign(this.metodologia, this._beforeEditingCache);
      this.originalData = this._beforeEditingCache = null;
      this.modalEditarMetodologia = false;
    }
  },
  components: components
};
</script>

<style></style>
